<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-UploadFirmware-Title" slot="header">{{ $t('firmwareUploadDialogTitle') }}</span>
    <el-form ref="data" :model="data" id="uploadform" @submit.native.prevent="uploadFirmware" enctype="multipart/form-data" label-position="left">
      <el-form-item
        :error="errors.has('version') ? $t('firmwareUploadInputVersionError') : ''"
        :label="$t('firmwareUploadInputVersionLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('version')"
        data-qa="Dialog-UploadFirmwareVersion-Item"
      >
        <el-input
          :placeholder="$t('firmwareUploadInputVersionPlaceholder')"
          clearable
          data-qa="Dialog-UploadFirmwareVersion-Input"
          name="version"
          required
          type="text"
          v-model="data.version"
          v-validate="{ rules: { required: true, regex: validate.semver} }"
        />
      </el-form-item>
      <el-form-item
        :error="errors.has('previous') ?  $t('firmwareUploadInputPreviousError'): ''"
        :label="$t('firmwareUploadInputPreviousLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('previous')"
        data-qa="Dialog-UploadFirmwarePreVersion-Item"
      >
        <el-input
          :placeholder="$t('firmwareUploadInputPreviousPlaceholder')"
          clearable
          data-qa="Dialog-UploadFirmwarePreVersion-Input"
          name="previous"
          required
          type="text"
          v-model="data.lastVersion"
          v-validate="{ rules: { required: true, regex: validate.semver} }"
        />
      </el-form-item>
      <el-form-item
        :error="errors.has('sha1') ? $t('firmwareUploadInputSHA1Error') : ''"
        :label="$t('firmwareUploadInputSHA1Label')"
        :label-width="labelWidth"
        :show-message="errors.has('sha1')"
        data-qa="Dialog-UploadFirmwareSHA1-Item"
      >
        <el-input
          :placeholder="$t('firmwareUploadInputSHA1Label')"
          clearable
          data-qa="Dialog-UploadFirmwareSHA1-Input"
          name="sha1"
          required
          type="text"
          v-model="data.sha1"
          v-validate="{ rules: { required: true, regex: validate.sha1} }"
        />
      </el-form-item>
      <el-form-item
        :error="errors.has('model') ? $t('firmwareUploadInputModelError') : ''"
        :label="$t('firmwareUploadInputModelLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('model')"
        data-qa="Dialog-UploadFirmwareModel-Item"
      >
        <el-input
          :placeholder="$t('firmwareUploadInputModelLabel')"
          clearable
          data-qa="Dialog-UploadFirmwareModel-Input"
          name="model"
          required
          type="text"
          v-model="data.model"
          v-validate="{ rules: { required: true } }"
        />
      </el-form-item>
      <el-form-item
        :label="$t('firmwareUploadInputTriggerLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('trigger')"
        data-qa="Dialog-UploadFirmwareTrigger-Item"
      >
        <el-switch
          :placeholder="$t('firmwareUploadInputTriggerLabel')"
          clearable
          data-qa="Dialog-UploadFirmwareTrigger-Input"
          name="trigger"
          v-model="data.trigger"
        />
      </el-form-item>
      <el-form-item
        :label="$t('firmwareUploadInputImageLabel')"
        :label-width="labelWidth"
        data-qa="Dialog-UploadFirmwareImage-Item"
      >
        <div class="upload-block">
          <input
            :id="uploadFieldName"
            :name="uploadFieldName"
            @change="filesChange($event.target.name, $event.target.files)"
            class="input-file"
            data-qa="Dialog-UploadFirmwareImage-UploadField"
            required
            type="file"
            v-bind="data.imgFile"
            v-validate="'required|size:4096'"
          >
          <label :for="uploadFieldName" class="el-button el-button--default">{{ $t('firmwareUploadInputUploadFieldNameLabel') }}</label>
          <div class="selected-file-name">{{ getFileName }}</div>
        </div>
        <div class="help is-danger" v-if="errors.has(uploadFieldName)">
          {{ $t('firmwareUploadTipImage') }}
        </div>
      </el-form-item>
    </el-form>
    <span slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-UploadFirmware-Button-Close"
        type="text"
      >
        {{ $t('firmwareUploadDialogButtonCloseText') }}
      </el-button>
      <el-button
        @click="uploadFirmware"
        :disabled="loading || errors.any()"
        :loading="loading"
        data-qa="Dialog-UploadFirmware-Button-Upload"
        type="warning"
      >
        {{ $t('firmwareUploadDialogButtonUploadText') }}
      </el-button>
    </span>
  </hamv-dialog>
</template>

<script>
import main from './FirmwareUpload.js'
export default main
</script>

<style lang="scss" scoped>
@import './FirmwareUpload.scss'
</style>



// WEBPACK FOOTER //
// FirmwareUpload.vue?4f7921ca